<template>
  <b-modal v-model="display"
           @ok="saveData"
           @shown="clearName"
           :ok-disabled="state.isAdding">
    <div slot="modal-title">
      {{ $t('message.booking.contact_step.save_my_place') }}
    </div>
    <section class="section-save-place text-black">
      <!-- Place name -->
      <div class="form-group">
        <label for="place-name">{{ $t('message.booking.contact_step.place_name') }}</label>
        <div class="text-remark mb-2">{{ $t('message.booking.contact_step.place_name_remark') }}</div>
        <input type="text"
               class="form-control input-jumbo"
               ref="placeName"
               id="place-name"
               v-model="placeName" required>
      </div>
      <!-- Checklist -->
      <hr>
      <div class="mt-3">
        <label>{{ $t('message.my_listings.checklist') }}</label>
        <div class="text-remark mb-2">{{ $t('message.my_listings.checklist_remark') }}</div>
      </div>
      <div class="form-inline row">
        <input id="checklist"
               type="text"
               class="form-control col-8 col-sm-8"
               :placeholder="$t('message.my_listings.add_checklist')"
               v-model="checklistData"
               @keyup.enter="addChecklist">
        <button type="button" class="btn btn-success ml-2 " @click="addChecklist">
          <i class="far fa-plus"></i> {{ $t('message.button.add') }}
        </button>
      </div>
      <div>
        <draggable v-model="arrChecklist">
          <div class="card" v-for="checklist, index in arrChecklist" :key="index">
            <div class="card-body py-2">
              <div class="row">
                <div class="col-10 p-0">
                  <i class="fas fa-check -status-accepted"></i>&nbsp;
                  {{ checklist }}
                </div>
                <div class="col-2 p-0 text-right">
                  <i class="fas fa-times pointer-item" @click="removeChecklist(index)"></i>
                </div>
              </div>
            </div>
          </div>
        </draggable>
      </div>
    </section>
    <div slot="modal-cancel" @click="display = false">{{ $t('message.button.close') }}</div>
    <div slot="modal-ok">{{ $t(isAdding) }}</div>
  </b-modal>
</template>

<script>
  import { mapGetters } from 'vuex'
  import draggable from 'vuedraggable'

  export default {
    props: {
      selectedPetTypes: Array
    },
    components: {
      draggable
    },
    data () {
      return {
        display: false,
        placeName: '',
        arrChecklist: [],
        checklistData: null
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        isAdding: 'booking/isAdding',
        preBookingData: 'booking/getPreBookingData',
        preCheckoutData: 'booking/getPreCheckoutData',
        state: 'booking/getState',
        user: 'auth/getUser'
      })
    },
    watch: {
      isAdding () {
        // If finish adding new user place
        if (!this.state.isAdding) {
          this.fetchUserPlaces()
          this.showModal(false)
          // Hide contact form and display detail
          this.$parent.setIsEditing(false)
        }
      }
    },
    methods: {
      addChecklist () {
        if (this.checklistData) {
          this.arrChecklist.push(this.checklistData)
          this.checklistData = ''
        }
      },
      removeChecklist (index) {
        this.arrChecklist.splice(index, 1)
      },
      fetchUserPlaces () {
        const queryUserPlaceData = {
          user_id: this.user.id,
          province_id: 0
        }
        this.$store.dispatch('booking/LOAD_USER_PLACE_LIST', queryUserPlaceData)
      },
      showModal (status) {
        this.display = status
      },
      clearName () {
        this.placeName = ''
      },
      saveData (evt) {
        // Prevent modal from closing
        evt.preventDefault()
        if (this.placeName) {
          const checklist = this.arrChecklist.length > 0 ? this.arrChecklist : null
          const latitude = this.preCheckoutData.user_place.latitude ? Number(this.preCheckoutData.user_place.latitude) : null
          const longitude = this.preCheckoutData.user_place.longitude ? Number(this.preCheckoutData.user_place.longitude) : null

          let placeSizeId = this.preBookingData.place_size_id
          if (this.preCheckoutData.user_place && this.preCheckoutData.user_place.place_size_id) {
            placeSizeId = this.preCheckoutData.user_place.place_size_id
          }
          // Prepare submit data
          const submitData = {
            user_id: this.user.id,
            place_name: this.placeName,
            place_size_id: placeSizeId,
            work_hour: this.preBookingData.work_hour,
            province_id: this.preCheckoutData.province_id,
            address: this.preCheckoutData.address,
            latitude: latitude,
            longitude: longitude,
            remark: this.preCheckoutData.remark,
            has_pet: this.preCheckoutData.user_place.has_pet,
            pet_remark: this.preCheckoutData.user_place.pet_remark,
            tel: this.preCheckoutData.tel,
            checklist: checklist,
            address_province_id: this.preCheckoutData.address_province_id,
            district_id: this.preCheckoutData.district_id,
            sub_district_id: this.preCheckoutData.sub_district_id
          }
          // Check selected pet types
          if (this.selectedPetTypes) {
            const petTypeIds = this.selectedPetTypes.map(petType => petType.id)
            submitData.pet_type_ids = petTypeIds
            // Get pet type remark
            const otherPet = this.selectedPetTypes.find(petType => petType.is_other === 1)
            if (otherPet && otherPet.remark) {
              submitData.pet_type_remark = otherPet.remark
            }
          }
          // Add new listing
          this.$store.dispatch('booking/ADD_USER_PLACE', submitData)
        } else {
          this.$refs.placeName.focus()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/booking/components/SavePlaceModal.vue